import React from "react";
import SubmittedAgreement from "../../sumitted_agreement/SubmittedAgreement";

const RecordedApprovedAgreement = () => {
  const fileStatus = 28;
  const applicationPath = {
    copyright: "/admin/recorded-approved-copyright",
    agreement: "/admin/recorded-approved-agreement",
  };
  
  // Add route to details page
  const detailsRoute = "/admin/recorded-agreement-details";
  const pageTitle = "নথিজাত অনুমোদিত";

  return (
    <SubmittedAgreement
      fileStatus={fileStatus}
      applicationPath={applicationPath}
      detailsRoute={detailsRoute}
      pageTitle={pageTitle}
    />
  );
};

export default RecordedApprovedAgreement;
